module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_07-d6cf7855f139902b9ba8ceeb1fb40f55.jpg";